import * as React from 'react';
import {Route} from 'react-router';
import HeaderView from './HeaderView';
import StepView from './StepView';
import FooterView from './FooterView';
import ModalContainer from '../../containers/ModalContainer';
import LoaderContainer from '../../containers/LoaderContainer';
import AlertContainer from '../../containers/mx/creditoReal/AlertContainer';
import {PageProps} from '../../types/mx/creditoReal/components';
import AssetsManager from '../../../common/utils/AssetsManager';
import CustomerChat from '../../../common/components/CustomerChat';
import {PURPLE} from '../../../common/constants/Colors';
import {FACEBOOK_PAGE_ID} from '../../constants/MotorcreditConstants';
import {LOAN_APPLICATION_MX, LOGIN} from '../../constants/LabelConstants';
import Assistant from '../../../common/components/Assistant';
import LoadingView from './mx/LoadingView';
import Button from '../../../common/components/Button';
import MobileMenu from '../../../common/components/MobileMenu';
import {APP_WEB} from '../../constants/GlobalConstants';
import MotorfyIcon from '../../../common/components/MotorfyIcon';
import {ChildrenProps} from '../../../admin/commissions/common/types/components';

class PageView extends React.Component <PageProps & ChildrenProps, {}> {

    constructor(props) {
        super(props);
        if (this.props.needsLogin && !this.props.isLoggedIn) {
            this.props.goToLoginAndRedirect(this.props.computedMatch.url);
        }
    }

    static defaultProps = {
        hideHeader: false,
        hideFooter: false,
        hideBrandWizard: false,
        isLoggedIn: false,
        landing: false,
        simulator: false
    };

    componentDidMount() {
        setTimeout(() => {
            this.props.onLoad(this.props.step, this.props.highestStep);
        }, 500);
        this.props.onUTMData(location.search);
    }

    componentDidUpdate(prevProps, prevState) {
        if ((prevProps.needsLogin !== this.props.needsLogin) && this.props.needsLogin && !this.props.isLoggedIn) {
            prevProps.goToLoginAndRedirect(this.props.computedMatch.url);
        }
        if (prevProps.step && this.props.step &&
            (prevProps.step !== this.props.step || prevProps.highestStep !== this.props.highestStep)) {
            setTimeout(() => {
                prevProps.onLoad(this.props.step, this.props.highestStep);
            }, 500);
        }
    }

    hasStep = () => (this.props.step && this.props.step != '-') || this.props.sidebar != null;

    render() {
        const {
            steps, stepNameSelected, stepPercentageSelected, stepIdSelected, onPressBackStep, landing, customClass,
            hideBrandWizard, hideFooter, hideHeader, fluidLayout, country, simulatorTurboCash, assistantInformation,
            mainStep, bureauAlreadyValidated, onPressModalAssistant, needsLogin, isLoggedIn, onPressLogout, turboCash,
            app, simulatorProfileCreditoReal
        } = this.props;
        if (needsLogin && !isLoggedIn) {
            return <LoadingView description={LOGIN.SSO_LOADING} className="pt-5" />;
        }
        const classLanding = landing && app === APP_WEB ? 'wrapper-landing' : 'h-100';
        return (
            <React.Fragment>
                <div className={`wrapper ${classLanding} ${customClass ? customClass : ''}`}>
                    {!!!hideHeader && app === APP_WEB &&
                        <HeaderView country={country} landing={landing} simulatorTurboCash={simulatorTurboCash}
                                turboCash={turboCash} simulatorProfileCreditoReal={simulatorProfileCreditoReal}/>}
                    <div className={
                        `container${fluidLayout ? '-fluid' : ''} ${fluidLayout ? 'h-100' : ''}`
                    }>
                        <div className={`row ${landing ? 'h-100 mb-5' : 'wrapper-content'}`}>
                            {this.hasStep() && !landing &&
                            <div className="col-lg-3 col-md-4 col-sm-12 wrapper-sidebar d-flex flex-column">
                                <div className="row mt-4 mb-4 d-none d-sm-none d-md-block">
                                    <div className="col text-center">
                                        <MotorfyIcon
                                            color={landing ? 'white' : ''} customClass="navbar-brand-img-lg"/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <StepView steps={steps}
                                                  mainStep={mainStep}
                                                  stepNameSelected={stepNameSelected}
                                                  stepPercentageSelected={stepPercentageSelected}
                                                  stepIdSelected={stepIdSelected}
                                                  onPressBackStep={onPressBackStep}
                                                  bureauAlreadyValidated={bureauAlreadyValidated}/>
                                    </div>
                                </div>
                                <MobileMenu assistantInformation={assistantInformation}
                                            onPressModalAssistant={onPressModalAssistant}
                                            onClickLogout={onPressLogout}/>
                                {assistantInformation &&
                                <div className="row mt-auto d-none d-sm-none d-md-block">
                                    <div className="col">
                                        <Assistant assistantInformation={assistantInformation} onPress={() => {}}/>
                                    </div>
                                </div>}
                            </div>}
                            <div className="wrapper-wizard col">
                                {!landing && isLoggedIn && <div className="logout d-none d-sm-none d-md-block">
                                    <Button onPress={onPressLogout} type="small-outlined"
                                            customClass="ml-2" text="Cerrar Sesión"
                                            icon="/assets/images/common/close-session-icon.svg"/>
                                </div>}
                                <Route {...this.props}/>
                                {!hideBrandWizard &&
                                <div className="brand-wizard d-none d-sm-none d-md-block">
                                    <span className="text-muted small text-center text-md-right">
                                        Con el respaldo de:
                                        <a href="http://www.seminuevos.com/">
                                            <img className="navbar-brand-img-md pl-1" alt="seminuevos"
                                                 src={AssetsManager('/assets/images/common/logo-seminuevos.svg')}/>
                                        </a>
                                    </span>
                                </div>}
                            </div>
                        </div>
                    </div>
                    <CustomerChat color={PURPLE}
                                  pageId={FACEBOOK_PAGE_ID(country)}
                                  messageToUserHasLogged={LOAN_APPLICATION_MX.MESSAGE_TO_USER_HAS_LOGGED}
                                  messageToUserHasNotLogged={LOAN_APPLICATION_MX.MESSAGE_TO_USER_HAS_NOT_LOGGED}
                                  minimized="true"/>
                    {!!!hideFooter && app === APP_WEB && <FooterView/>}
                </div>
                <ModalContainer/>
                <LoaderContainer/>
                <AlertContainer/>
            </React.Fragment>
        );
    }
}

export default PageView;
